import {useMessage} from '@coolcolduk/ui-mui';
import {Grid, Typography} from '@mui/material';
import {useEffect} from 'react';
import {ContactCategory} from '../../__generated__/resolvers-types';
import ContactUsDialogForm from '../../components/contactUs/ContactUsDialogForm';
import useCreateContactMessage from '../../hook/useCreateContactMessage';

export default function ContactPage() {
  const {createContactMessage, data, error} = useCreateContactMessage();
  const {showMessage} = useMessage();

  useEffect(() => {
    if (data) {
      showMessage('Message sent successfully', undefined, 'success');
    }
    if (error) {
      showMessage('Failed to send message', undefined, 'error');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify({data, error})]);

  return (
    <Grid container direction="column" spacing={2}>
      <Typography variant="h1" component="h1" gutterBottom align="center">
        Contact Us
      </Typography>
      <Typography variant="h5" component="h2" gutterBottom align="center" color="text.secondary" sx={{mb: 6}}>
        Get in touch with our team for any questions or support
      </Typography>

      <Grid container spacing={8}>
        <Grid size={{xs: 12}}>
          <Typography variant="body1" align="center">
            We&apos;re here to help you succeed with your Etsy business. Whether you have questions about our tools,
            need technical support, or want to share feedback, our team is ready to assist you.
          </Typography>
          <Typography variant="body1" align="center">
            Use the chat button in the bottom right corner to start a conversation with us.
          </Typography>
        </Grid>
      </Grid>

      <ContactUsDialogForm categories={Object.values(ContactCategory)} user={null} onSubmit={createContactMessage} />
    </Grid>
  );
}
